import { Alert } from '@trussworks/react-uswds';
import Question from './Question';
import { MarkdownRenderer } from '@src/app-components/markdown-renderer/MarkdownRenderer';

const Section = ({
  componentId,
  isInformation,
  isReadOnly,
  onChange = () => {},
  sectionData,
  jpaFormDocuments,
  stepNo,
}) => (
  <section className='ddf-section'>
    <h3 className='ddf-section-title'>{sectionData.sectionName}</h3>
    {sectionData.additionalInfo && (
      <Alert className='ddf-section-info callout' noIcon slim>
        <MarkdownRenderer text={sectionData.additionalInfo} />
      </Alert>
    )}
    {sectionData.jpaQuestions.map((questionData) => (
      <Question
        jpaFormDocuments={jpaFormDocuments}
        isInformation={isInformation}
        componentId={componentId}
        isReadOnly={isReadOnly}
        jpaFormID={sectionData.jpaFormID}
        key={questionData.jpaQuestionID}
        onChange={onChange}
        questionData={questionData}
        stepNo={stepNo}
      />
    ))}
  </section>
);

export default Section;
